import { render, staticRenderFns } from "./healthCode.vue?vue&type=template&id=f9d4e00e"
import script from "./healthCode.vue?vue&type=script&lang=js"
export * from "./healthCode.vue?vue&type=script&lang=js"
import style0 from "./healthCode.vue?vue&type=style&index=0&id=f9d4e00e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports